export const WORKSPACE_TABS = ['tasks', 'docs', 'activity', 'overview'] as const
export type WorkspaceTab = typeof WORKSPACE_TABS[number]

/** Parse #/projects/:id/workspace[/tasks|docs|activity|overview]. */
export function parseWorkspaceHash(hash: string): { projectId: string; tab: WorkspaceTab } | null {
  const path = hash.replace(/^#/, '').replace(/^\//, '')
  const segments = path.split('/').filter(Boolean)
  if (segments[0] !== 'projects' || segments.length < 3 || segments.length > 4) return null
  if (segments[2] !== 'workspace') return null

  let projectId: string
  try {
    projectId = decodeURIComponent(segments[1])
  } catch {
    return null
  }
  if (!projectId) return null

  const requestedTab = segments[3]
  if (!requestedTab) return { projectId, tab: 'tasks' }
  if (!WORKSPACE_TABS.includes(requestedTab as WorkspaceTab)) return null
  return { projectId, tab: requestedTab as WorkspaceTab }
}

/** Build the hash path consumed by parseWorkspaceHash. */
export function workspacePath(projectId: string, tab: WorkspaceTab = 'tasks'): string {
  const base = '/projects/' + encodeURIComponent(projectId) + '/workspace'
  return tab === 'tasks' ? base : base + '/' + tab
}
